import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { appendToRmaApiUrl } from '@rma/generic/ng/util';
import { PagedList } from '@rma/public/generic/domain/types';
import { Observable } from 'rxjs';
import { AgentDetails, Market, SortByType } from '../domain/agent';

@Injectable({
  providedIn: 'root',
})
export class CompareAgentService {
  private readonly httpClient = inject(HttpClient);
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);

  // `take` is the only page-size parameter this endpoint honours — `filter.take` and `pageSize` are
  // ignored — and it is omitted entirely when unset so an existing caller keeps the server default
  // of ten rather than silently changing the request it has always made.
  public agents(agentCodes: string[], sortBy: SortByType = 'TotalReviews', take?: number): Observable<PagedList<AgentDetails>> {
    return this.httpClient.get<PagedList<AgentDetails>>(this.rmaApiUrl('users/me/shortlist/agents'), {
      params: take === undefined ? { agentCodes, sortBy } : { agentCodes, sortBy, take },
    });
  }

  public markets(agentCodes: string[]): Observable<PagedList<Market>> {
    return this.httpClient.get<PagedList<Market>>(this.rmaApiUrl('users/me/shortlist/agents/markets'), {
      params: { agentCodes },
    });
  }
}
